import { Component, OnInit } from '@angular/core';
import { BroadcastService } from './../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../services/infrastructure/config.service';

@Component({
  selector: 'app-unauthorize',
  templateUrl: './unauthorize.component.html',
  styleUrls: ['./unauthorize.component.scss']
})
export class UnAuthorizeComponent implements OnInit {
  constructor(
    private broadcastService: BroadcastService,
    private configService: ConfigService) { }

  ngOnInit() {
    this.broadcastService.broadcast(this.configService.IS_AUTHORIZE, { isAuthorize: false });
  }
}
